import { useT } from "./i18n";
import type { MessageFilters } from "./messageFilters";

/** One control for the criterion and direction, shared by messages and correspondence. */
export function MessageSort({ value, onChange }: { value: MessageFilters; onChange: (value: MessageFilters) => void }) {
  const t = useT();
  return <label className="sort-control">
    <span>{t.browse.sort}</span>
    <select aria-label={t.browse.sort} value={`${value.sort}:${value.direction}`} onChange={(e) => {
      const [sort, direction] = e.target.value.split(":") as [MessageFilters["sort"], MessageFilters["direction"]];
      onChange({ ...value, sort, direction });
    }}>
      <option value="opens:desc">{t.design.sortOpeningLatest}</option>
      <option value="opens:asc">{t.design.sortOpeningEarliest}</option>
      <option value="received:desc">{t.design.sortReceivedLatest}</option>
      <option value="received:asc">{t.design.sortReceivedEarliest}</option>
    </select>
  </label>;
}
